









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})

export default class ItemsTick extends Vue {
  @Prop() items: string[]
}
